/**
 * @itemgo/service-move
 * ItemGo Service Move Plugin — House Removals
 */

export { moveManifest } from "./manifest.js";

import { moveManifest } from "./manifest.js";
import type { PluginModule } from "@itemgo/core";
import { calculateFullPricing } from "./services/pricing.js";
import { useMovePricing } from "./hooks/useMovePricing.js";
import { MovePricingBreakdown } from "./components/MovePricingBreakdown.js";

export const movePlugin: PluginModule = {
  manifest: moveManifest,
  services: {
    calculatePrice: calculateFullPricing as unknown as (params: unknown) => Promise<unknown>,
  },
  hooks: {
    usePricing: useMovePricing as unknown as () => unknown,
  },
  components: {
    PriceCalculator: MovePricingBreakdown as unknown as React.ComponentType<unknown>,
  },
};

// Types
export type {
  VehicleType,
  RoomType,
  RoomItem,
  AddOnDetail,
  VolumeEstimate,
  FullPricingInput,
  FullPricingResult,
  MovePricingConfig,
  FurnitureItem,
  FurnitureInventory,
  RoomFurniture,
} from "./types.js";

// Schema
export { moveSchema, roomItemSchema, difficultyLevels, packingServices, roomTypes } from "./schema.js";
export type { MoveFormData, RoomItemForm } from "./schema.js";

// Services
export {
  calculateFullPricing,
  formatPence,
  formatCommissionRate,
  DEFAULT_MOVE_PRICING_CONFIG,
} from "./services/pricing.js";

export {
  VEHICLE_SPECS,
  VEHICLE_ORDER,
  canVehicleHandleLoad,
  findSmallestVehicleForLoad,
  calculateVolumeM3,
  getVehicleUpgradePath,
  getDefaultDimensionsCm,
  m3ToFt3,
  ft3ToM3,
} from "./services/vehicleCalculator.js";

export {
  generateVolumeEstimate,
  estimateVolumeByRooms,
  getRecommendedVehicle,
  ROOM_VOLUMES,
  HOUSE_CONFIGURATIONS,
} from "./services/volumeEstimation.js";

// React Hooks
export { useMovePricing } from "./hooks/useMovePricing.js";
export { useVolumeEstimator } from "./hooks/useVolumeEstimator.js";

// React Components
export { MovePricingBreakdown } from "./components/MovePricingBreakdown.js";
export { VolumeEstimator } from "./components/VolumeEstimator.js";
export { MoveManifest } from "./components/MoveManifest.js";
export { RoomInventoryEditor } from "./components/RoomInventoryEditor.js";

// Item Catalog
export {
  ROOM_FURNITURE_CATALOG,
  BOX_VOLUME_FT3,
  calculateFurnitureVolume,
  calculateTotalVolume,
  getFurnitureForRoom,
  findFurnitureItem,
} from "./data/itemCatalog.js";
